import Trans from "features/translation/components/Trans";
import FilterControls from "features/view/components/Filters/FilterControls";
import Alert from "components/ui/Alert/Alert";
import Filters from "features/view/components/Filters/Filters";
import Empty from "features/view/components/Empty/Empty";
import ViewPager from "features/view/components/Pager/ViewPager";
import { useView } from "features/view/context/ViewContext";
import GroupTeaser from "features/groups/components/GroupTeaser";
import PropTypes from "prop-types";
import { useAccount } from "context/AccountContext";
import Loader from "components/ui/Loader/Loader";

const ViewGroups = ({ layoutPersonal = false }) => {
  const { view, isLoading } = useView();
  const { user } = useAccount();

  if (!isLoading && !view) {
    return <Alert/>;
  }

  let content = view?.search_results && view.search_results.map(
    (row, index) => <GroupTeaser key={ index }
                                 nid={ parseInt(row.nid) }
                                 name={ row.title }
                                 photo={ row.field_group_photo }
                                 distance={ row.location_distance?.toString() }
                                 description={ row.field_description }
                                 participants={ parseInt(row.member_count) }
                                 url={ row.url }
                                 isPrivate={ row.is_private === '1' }
                                 isOwner={ parseInt(row.uid) === parseInt(user.id) }
                                 teaserVariant={ layoutPersonal ? 'dark' : 'wide' }
                                 buttonVariant={ layoutPersonal ? 'white' : 'light' }
                                 labelVariant={ layoutPersonal ? 'light' : '' }
                      />);
  if (!content && !isLoading) {
    content =
      <Empty><Trans text={ 'Er zijn geen groepen gevonden die aan alle filtervoorwaarden voldoen.' }/></Empty>;
  }


  if (layoutPersonal) {
    return (
      <div className={ 'teasers-container--1col' }>
        { content }
      </div>
    );
  }

  return (
    <>
      <div className={ 'grid--filter' }>
        <Filters hasLocation={ true }/>
      </div>

      <div className={ 'grid--content' }>
        <FilterControls/>
        { isLoading ? <Loader containerVariant={ 'center' }/> : content }
        <ViewPager/>
      </div>
    </>
  );
}

ViewGroups.propTypes = {
  layoutPersonal: PropTypes.bool,
}

export default ViewGroups;
